import { useEffect } from 'react';
import { $t } from 'hooks/i18n';
import { CanView } from 'components/Can';
import { TabView, TabPanel } from 'primereact/tabview';
import { Title } from 'components/Title';
import GrouploanamortListPage from 'pages/grouploanamort/List';
import LoanguarantorListPage from 'pages/loanguarantor/List';
import useApp from 'hooks/useApp';

const MasterDetailPages = (props) => {
		const app = useApp();
	const { masterRecord, scrollIntoView = true } = props;
	const activeTab = 0;
	function scrollToDetailPage() {
		if (scrollIntoView) {
			const pageElement = document.getElementById('master-detailpage');
			if(pageElement){
				pageElement.scrollIntoView({behavior:'smooth', block:'start'});
			}
		}
	}
	// pass form data from master to detail
	function setDetailPageFormData(){
		const record = masterRecord;
		// set  form data
		const grouploanamortFormData = { loanaccountno:record?.loanaccountno }
		app.setPageFormData('grouploanamort', grouploanamortFormData);
		// set  form data
		const loanguarantorFormData = { loanaccountno:record?.loanaccountno }
		app.setPageFormData('loanguarantor', loanguarantorFormData);
	}
	// pass form data from master to detail
	useEffect(() => {
		scrollToDetailPage();
		setDetailPageFormData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [masterRecord]);
	if(masterRecord){
		return (
<div id="master-detailpage">
    <TabView value={activeTab}>
        <TabPanel header={<Title title={$t('amort')}  headerClass="p-0" titleClass="text-lg font-bold"  iconClass="pi pi-th-large" avatarSize="small"    separator={false} />}>
            <CanView pagePath="grouploanamort">
                <div className="reset-grid">
                    <GrouploanamortListPage isSubPage  fieldName="loanaccountno" fieldValue={masterRecord.loanaccountno} showBreadcrumbs={false} showHeader={true} showFooter={true}>
                    </GrouploanamortListPage>
                </div>
            </CanView>
        </TabPanel>
        <TabPanel header={<Title title={$t('guarantors')}  headerClass="p-0" titleClass="text-lg font-bold"  iconClass="pi pi-th-large" avatarSize="small"    separator={false} />}>
            <CanView pagePath="loanguarantor">
                <div className="reset-grid">
                    <LoanguarantorListPage isSubPage  fieldName="loanaccountno" fieldValue={masterRecord.loanaccountno} showBreadcrumbs={false} showHeader={true} showFooter={true}>
                    </LoanguarantorListPage>
                </div>
            </CanView>
        </TabPanel>
    </TabView>
</div>
		);
	}
}
export default MasterDetailPages;
